import { memo, useEffect, useState } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { IconMy03 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  value?: number | string | undefined;
  selectedValue?: number | string | undefined;
  text?: string;
  dot?: boolean;
  textColor?: string;
  className?: string;
  my?: boolean;
  onClick?: () => void;
}

const MenuBarItem = ({
  value,
  selectedValue = '',
  text,
  dot,
  textColor = '',
  className,
  my = false,
  onClick,
}: IProps) => {
  const [activeValue, setActiveValue] = useState(String(value));
  const [$selectedValue, setSelectedValue] = useState(String(selectedValue));

  const cName = classNameBind([
    'menubar-item item',
    activeValue === $selectedValue ? 'active' : '',
    dot ? 'dot' : '',
    className || '',
  ]);

  useEffect(() => {
    setActiveValue(String(value));
    setSelectedValue(String(selectedValue));
  }, [selectedValue, value]);

  return (
    <S.MenuBarItem className={cName} $textcolor={textColor}>
      <Button className="area-click" onClick={onClick}>
        {/* pc에서 드래그 안되는 이슈로 span 추가 */}
        <span className="mnbrtm-inner">
          {my ? <IconMy03 className="icon-my" /> : undefined}
          {text}
        </span>
      </Button>
    </S.MenuBarItem>
  );
};

export default memo(MenuBarItem);
